import React, { useRef, useEffect, useState, useCallback } from 'react';

function MouseMovement({ data }) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const iframeRef = useRef(null);
  const [opacity, setOpacity] = useState(0.3);
  const [iframeHeight, setIframeHeight] = useState(2000);

  const allMoves = data.flatMap(d => (d.moves || []).map(m => ({
    x: m.x,
    y: m.y,
    pageWidth: d.page ? d.page.width : 1440,
    pageHeight: d.page ? d.page.height : 900,
  })));

  const drawHeatmap = useCallback(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container || allMoves.length === 0) return;

    const displayWidth = container.clientWidth;
    const maxPageWidth = Math.max(...allMoves.map(m => m.pageWidth), 1440);
    const scale = displayWidth / maxPageWidth;

    canvas.width = displayWidth;
    canvas.height = iframeHeight;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const cellSize = 10;
    const cols = Math.ceil(canvas.width / cellSize);
    const rows = Math.ceil(canvas.height / cellSize);
    const grid = new Float32Array(cols * rows);

    allMoves.forEach(move => {
      const x = Math.floor((move.x * scale) / cellSize);
      const y = Math.floor((move.y * scale) / cellSize);
      if (x >= 0 && x < cols && y >= 0 && y < rows) {
        grid[y * cols + x]++;
      }
    });

    const maxDensity = Math.max(...grid, 1);

    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const val = grid[row * cols + col];
        if (val === 0) continue;
        const norm = val / maxDensity;
        let r, g, b;
        if (norm < 0.33) {
          r = 0; g = Math.round(norm * 3 * 255); b = 255;
        } else if (norm < 0.66) {
          r = Math.round((norm - 0.33) * 3 * 255); g = 255; b = Math.round((1 - (norm - 0.33) * 3) * 255);
        } else {
          r = 255; g = Math.round((1 - (norm - 0.66) * 3) * 255); b = 0;
        }
        ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${opacity})`;
        ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
      }
    }

    ctx.fillStyle = 'rgba(0,0,0,0.6)';
    ctx.fillRect(0, 0, 140, 28);
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 13px sans-serif';
    ctx.fillText(`${allMoves.length} ポイント`, 10, 18);
  }, [allMoves, opacity, iframeHeight]);

  useEffect(() => {
    drawHeatmap();
  }, [drawHeatmap]);

  const handleIframeLoad = () => {
    try {
      const doc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      setIframeHeight(doc.documentElement.scrollHeight);
    } catch {
      setIframeHeight(3000);
    }
  };

  if (allMoves.length === 0) {
    return (
      <div className="empty-state">
        <div className="icon">🔥</div>
        <h3>マウス移動データがありません</h3>
        <p>ユーザーがページ上でマウスを動かすとデータが表示されます</p>
      </div>
    );
  }

  return (
    <div>
      <div className="heatmap-controls">
        <label>
          透過度: {opacity}
          <input type="range" min="0.1" max="1" step="0.05" value={opacity} onChange={e => setOpacity(Number(e.target.value))} />
        </label>
      </div>
      <div
        ref={containerRef}
        style={{
          position: 'relative',
          width: '100%',
          height: iframeHeight,
          overflow: 'hidden',
          borderRadius: 8,
          border: '1px solid #2d333b',
        }}
      >
        <iframe
          ref={iframeRef}
          src="/api/lp"
          title="LP Preview"
          onLoad={handleIframeLoad}
          style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
        />
        <canvas
          ref={canvasRef}
          style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            pointerEvents: 'none',
          }}
        />
      </div>
    </div>
  );
}

export default MouseMovement;
